import isMobile from 'ismobilejs'

export default {
  name: 'share',

  ui: {
    'buttons[]': '[js-share-button]',
    shareToggle: '[js-share-toggle]',
  },

  events: [
    {
      on: 'click',
      target: 'buttons',
      handle (e) {
        if (navigator.share && isMobile().any) {
          navigator.share({
            title: e.target.dataset.title,
            text: e.target.dataset.text,
            url: document.location.href,
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error))
        } else {
          this.ui.shareToggle.classList.toggle('is-visible')
        }
      },
    },
  ],

  componentDidMount () {
    document.addEventListener('click', (e) => {
      if (
        e.target !== (this.ui.buttons) &&
        e.target.closest('[js-share]') === null &&
        this.ui.shareToggle.classList.contains('is-visible')
      ) {
        this.ui.shareToggle.classList.remove('is-visible')
      }
    })
  },
}
